export const LOCATION_COUNTS_SAVED_KEY = 'locationCounts'
export const LOCATION_COUNTS_CURRENT_KEY = 'locationCounts.currentCount'
export const LOCATION_COUNTS_UPLOAD_RESULTS_KEY = 'locationCounts.uploadResults'
export const LOCATION_COUNTS_COMPLETED_RESULTS_KEY = 'locationCounts.completedResults'
